import styled from 'styled-components';
import { LazyImage } from '../../../hydra/components/LazyImage/LazyImage';
export const StyledStaticLazyImage = styled(LazyImage) `
  width: ${({ width }) => `${width}px`};
  height: ${({ height }) => `${height}px`};
`;
//# sourceMappingURL=StyledStaticLazyImage.styled.js.map